import React, { useEffect, useState } from "react";
import AccessLocalStorage from "../../services/localStorage";
import {
  Button,
  Dialog,
  Grid,
  Typography,
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import JournalEntry from "./journalentryform";
import { buttonRed, lightcolor, pcolor, rcolor, whitecolor } from "../../style2";

export default function JournalAction(props) {
  const [showOptions, setShowOptions] = useState(false);
  const [showJournalForm, setShowJournalForm] = useState(false);
  const ls = new AccessLocalStorage();
  const isTeacher = ls.isTeacher();
  const renderJournalForm = () => {
    return (<JournalEntry id={0} successClose={() => { setShowJournalForm(false); props.onJournalCreated();}} open={showJournalForm} handleClose={() => { setShowJournalForm(false); }} />);
  }
  const renderOptions = () => {
    if (showOptions) {
      return (<Dialog open={true} maxWidth="xs" fullWidth >
        <Grid container xs={12} sx={{ border: `1px solid ${rcolor}`, borderRadius: "5px", backgroundColor: lightcolor }}>
          <Grid container item xs={12} sx={{ padding: "10px" }}>
            <Grid item xs={1}></Grid>
            <Grid item xs={10} sx={{ textAlign: "center" }}>
              <Typography sx={{ color: pcolor, fontWeight: "bold", fontSize: "20px", textTransform: "capitalize" }}>My Health Diary</Typography>
            </Grid>
            <Grid item xs={1} sx={{ color: rcolor, fontSize: "2rem", cursor: "pointer" }}>
              <CloseIcon onClick={() => { setShowOptions(false); }} />
            </Grid>
          </Grid>
          {/* <Grid item xs={12} sx={{ padding: "0px 20px 20px 20px", textAlign: "center" }}>
            <Button sx={{...button, width: "200px" }}>Use most recent template</Button>
          </Grid> */}
          <Grid item xs={12} sx={{ padding: "0px 20px 30px 20px", textAlign: "center" }}>
            <Button onClick={() => { setShowOptions(false); setShowJournalForm(true); }} sx={{...buttonRed, width: "200px" }}>Create New</Button>
          </Grid>
        </Grid>
      </Dialog>)
    }
    return null;
  }

  return (<>
    {renderOptions()}
    {renderJournalForm()}
    {isTeacher ? <div onClick={() => { setShowOptions(true); }} style={{ position: "fixed", cursor: "pointer", bottom: "40px", right: "70px", backgroundColor: rcolor, borderRadius: "5px", color: whitecolor, height: "40px", width: "40px", padding: "4px" }}>
      <AddIcon style={{ fontSize: "2rem" }} />
    </div> : null }
    </>);
}